'use client'
import { useState } from 'react'

export default function ContactModal({ showContactModalType, setShowContactModalType, invoiceData, setInvoiceData }) {
  const [inputFields, setInputFields] = useState(() => {
    const modalDetailsType = showContactModalType === "from" ? "senderDetails" : "recepientDetails"
    return {
      name: invoiceData?.[modalDetailsType]?.name,
      email: invoiceData?.[modalDetailsType]?.extraFields?.find(field => field?.key === 'email')?.value,
      address: invoiceData?.[modalDetailsType]?.extraFields?.find(field => field?.key === 'address')?.value
    }
  })

  const modalDetailsType = showContactModalType === "from" ? "senderDetails" : "recepientDetails"

  const handleSubmit = (e) => {
    e.preventDefault()
    const fields = Object.entries(inputFields).map(([key, value]) => ({
      key,
      value
    }))

    const name = fields.find(field => field.key === 'name')?.value
    const extraFields = fields.filter(field => field.key !== 'name')
    
    const updatedInvoiceData = {
      ...invoiceData,
      [modalDetailsType]: {
        name,
        extraFields
      }
    }

    setInvoiceData(updatedInvoiceData)
    setShowContactModalType(null)
  }

  if (!showContactModalType) return null

  const isFrom = showContactModalType === 'from'

  return (
    <div className="fixed inset-0 backdrop-blur-sm bg-opacity-50 flex items-center justify-center z-50 p-4 text-left">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-gray-800">
            {isFrom ? 'Sender Information' : 'Recipient Information'}
          </h2>
          <button 
            onClick={() => setShowContactModalType(null)}
            className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
              <input 
                type="text" 
                name="name"
                value={inputFields?.name || ''}
                onChange={(e) => setInputFields({ ...inputFields, name: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Enter name"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
              <input 
                type="email" 
                name="email"
                value={inputFields?.email || ''}
                onChange={(e) => setInputFields({ ...inputFields, email: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Enter email"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Address</label>
              <textarea 
                name="address"
                value={inputFields?.address || ''}
                onChange={(e) => setInputFields({ ...inputFields, address: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                rows={3}
                placeholder="Enter address"
              />
            </div>
          </div>
          
          <div className="flex space-x-3 mt-8">
            <button 
              type="button"
              onClick={() => setShowContactModalType(null)}
              className="flex-1 px-4 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium cursor-pointer"
            >
              Cancel
            </button>
            <button 
              type="submit"
              className="flex-1 px-4 py-3 bg-primary text-white rounded-lg hover:bg-blue-700 transition-colors font-medium cursor-pointer"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}